export default {
	project_name: 'UniFranquia Softys',
}
